/**
 * 
 * @file Open With dropdown menu item
 * @author Box
 */

import * as React from 'react';
import MenuItem from 'box-react-ui/lib/components/menu/MenuItem';
import IconFileDefault from 'box-react-ui/lib/icons/file/IconFileDefault';
import ICON_FILE_MAP from './IconFileMap';

var OpenWithDropdownMenuItem = function OpenWithDropdownMenuItem(_ref) {
    var _ref$integration = _ref.integration,
        displayName = _ref$integration.displayName,
        displayDescription = _ref$integration.displayDescription,
        appIntegrationId = _ref$integration.appIntegrationId,
        onClick = _ref.onClick;

    var Icon = ICON_FILE_MAP[displayName] || IconFileDefault;
    return React.createElement(
        MenuItem,
        { onClick: function (_onClick) {
                function onClick() {
                    return _onClick.apply(this, arguments);
                }

                onClick.toString = function () {
                    return _onClick.toString();
                };

                return onClick;
            }(function () {
                return onClick(appIntegrationId);
            }) },
        React.createElement(Icon, null),
        React.createElement(
            'span',
            null,
            React.createElement(
                'p',
                { className: 'bcow-menu-item-title' },
                displayName
            ),
            React.createElement(
                'p',
                { className: 'bcow-menu-item-description' },
                displayDescription
            )
        )
    );
};

export default OpenWithDropdownMenuItem;